import { combineReducers } from 'redux';
import apiKey from './apiKey';
import apiKeyId from '../setting/apiKeyId';

export default combineReducers({
  apiKey,
  apiKeyId,
});
